import "./lib/grpc-transport" // Initialize gRPC transport (must run before generated clients import)
import React from "react"
import { createRoot } from "react-dom/client"
import "./index.css"
import App from "./App"

const rootElement = document.getElementById("root")
if (!rootElement) {
  throw new Error("Root element not found")
}
const root = createRoot(rootElement)
root.render(<App />)
